import React from "react";
import { Chip } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";

// Custom renderer for compliance boolean fields
export const ComplianceIssueBooleanIcon = (params: GridRenderCellParams) => {
  const value = params.value;
  if (typeof value !== "boolean") return null;
  
  if (value === true) {
    return React.createElement(Chip, {
      label: "ISSUE",
      size: "small",
      color: "error",
      variant: "filled",
      sx: { 
        fontSize: '0.75rem',
        height: '20px',
        '& .MuiChip-label': {
          px: 1,
          fontWeight: 'bold'
        }
      }
    });
  }
  
  return React.createElement(Chip, {
    label: "OK",
    size: "small",
    color: "success",
    variant: "outlined",
    sx: { 
      fontSize: '0.75rem',
      height: '20px',
      '& .MuiChip-label': {
        px: 1
      }
    }
  });
};
